import { 
  HomeTrendUp, 
  Hospital, 
  Eye, 
  Add, 
  People, 
  UserEdit, 
  Shield, 
  Grid3, 
  TrendUp, 
  DocumentText,
  Setting2,
  UserSquare,
  Chart
} from 'iconsax-react';

export const sidebarConfig = [
  {
    section: "Navigation",
    items: [
      {
        label: "Dashboard",
        icon: HomeTrendUp,
        href: "/dashboard"
      }
    ]
  },
  {
    section: "Agency Management",
    items: [
      {
        label: "Healthcare Agencies",
        icon: Hospital,
        children: [
          { label: "All Agencies", href: "/tenants", icon: Eye },
          { label: "Create Agency", href: "/tenants/create", icon: Add }
        ]
      },
      {
        label: "Subscriptions",
        icon: Setting2,
        children: [
          { label: "Plan Catalog", href: "/subscriptions/plans", icon: Eye },
          { label: "Plan Assignment", href: "/subscriptions/assignments", icon: UserSquare },
          { label: "Audit Trail", href: "/subscriptions/audit", icon: Chart }
        ]
      }
    ]
  },
  {
    section: "System",
    items: [
      {
        label: "User Management",
        icon: People,
        href: "/users"
      },
      {
        label: "Role Assignment",
        icon: UserEdit,
        href: "/users/roles"
      },
      {
        label: "Role Management",
        icon: Shield,
        href: "/roles"
      },
      {
        label: "Permission Matrix",
        icon: Grid3,
        href: "/roles/permissions"
      },
      {
        label: "Role Analytics",
        icon: TrendUp,
        href: "/roles/analytics"
      },
      {
        label: "Audit Logs",
        icon: DocumentText,
        href: "/audit-logs"
      },
      {
        label: "Demo Data",
        icon: DocumentText,
        href: "/demo"
      }
    ]
  }
];
